import Accordeon from './components/Accordeon.js';
import Carousel from './components/Carousel.js';
import Code from './components/prism.js';
import RotationRandom from './components/RotationRandom.js';
import Form from './components/Form.js';
import ButtonActive from "./components/ButtonActive.js";
import Map from "./components/Map.js";
import Header from "./components/Header.js";
import Calendar from './components/Calendar.js';
import Tabs from './components/Tabs.js';
import Scrolly from './components/Scrolly.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Accordeon,
      RotationRandom,
      Carousel,
      Code,
      Form,
      Map,
      ButtonActive,
      Header,
      Calendar,
      Tabs,
      Scrolly,
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
